module.exports = __webpack_public_path__ + "assets/img/cipan.8d726fa4.png";